import styled from '@emotion/styled'
import React, { useState } from 'react'

import { Dropdown } from '@/components'
import { FilterActions, useFiltersContext } from '@/context'

export const StatusFilter = () => {
  const [{ notificationsFilters }, FilterDispatch] = useFiltersContext()
  const { status } = notificationsFilters
  const [dropdownExpanded, setDropdownExpanded] = useState(false)

  const handleCancel = () => {
    setDropdownExpanded(false)
  }

  const changeFilter = (val: string | null = null) => {
    setDropdownExpanded(false)
    if (val) {
      FilterDispatch(FilterActions.setFilters({ filterName: 'notifications', filters: { status: val } }))
    } else {
      FilterDispatch(FilterActions.setFilters({ filterName: 'notifications', filters: { status: null } }))
    }
  }

  return (
    <Dropdown
      className="w-full md:w-auto lg:flex"
      expanded={dropdownExpanded}
      headerTitle="Status"
      onHideDropdown={handleCancel}
      renderHeader={() => <div></div>}
      selected={!!status}
      setExpanded={setDropdownExpanded}
    >
      <FilterOptionsStyled>
        <ul>
          <li className={`${!status ? 'selected' : ''}`} onClick={() => changeFilter()} role={'presentation'}>
            All
          </li>

          <li
            className={`${status === 'unread' ? 'selected' : ''}`}
            onClick={() => changeFilter('unread')}
            role={'presentation'}
          >
            Unread
          </li>
        </ul>
      </FilterOptionsStyled>
    </Dropdown>
  )
}

export const FilterOptionsStyled = styled.div`
  width: 13rem;

  ul {
    width: 100%;
    padding-top: 0.5rem;
    padding-bottom: 0.25rem;
  }
  li {
    &.selected {
      background-color: #e7e6e4;

      &:hover {
        background-color: #e7e6e4;
      }
    }
    margin-bottom: 0.25rem;
    width: 100%;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    cursor: pointer;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    line-height: 1;
    &:hover {
      background-color: #f3f3f2;
    }
  }
`
